import { ASSET_PREFIX, colors } from 'utils/constants';
import css from 'styled-jsx/css';

const NothingHereMessage = () => (
  <div className='nothingHereMessageContainer'>
    <h4 style={{ textShadow: `2px 2px ${colors.brand.pastel}`, marginBottom: '1em' }}>
      OOPS!
    </h4>

    <div className='text'>
      There's nothing here...
    </div>
    <style jsx>{styles}</style>
  </div>
);

const styles = css`
.nothingHereMessageContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 2em;
}

.nothingHereMessageContainer :global(.text) {
  color: gray;
  font-size: 1.2em;
  margin-top: 0;
}
`;

export default NothingHereMessage;
